<template>
  <div>
    <div id="home"></div>

    <v-img src="/static/img/home/malina/1.jpg" class="rooms-img">
      <div class="offer1-mask text-xs-center">
        <v-container>
          <div class="offer1-offer">3 комфортных номера</div>
          <div class="offer1-sub-offer">Посуточная и почасовая аренда номеров. Бесплатный трансфер и Wi-Fi в каждом номере. Оформление командировочных документов.</div>

          <app-modal-form
            button-text="Забронировать номер"
            modal-form-header="Забронируйте"
            modal-form-sub-header="номер прямо сейчас"
            modal-form-button-text="Забронировать номер"
            form-name="Садко - Номера - главный"
          ></app-modal-form>

        </v-container>
      </div>
    </v-img>

    <v-container class="screen rooms">
      <v-layout row wrap justify-center class="row">
        <v-flex xs12>
          <h1 class="text-xs-center">Наши номера</h1>
        </v-flex>
        <v-flex
          d-flex
          xs12
          sm8
          md4
          v-for="room in rooms"
          :key="room.id"
        >
          <div class="rooms-block">
            <router-link :to="'/malina/room/' + room.id">
              <v-img :src="room.img"></v-img>
              <div style="padding: 15px;">
                <div class="rooms-h1">{{ room.name }}</div>
                <div class="rooms-description">{{ room.description }}</div>
                <div class="rooms-price">{{ room.price }}</div>
                <v-btn color="green" large flat>Подробнее</v-btn>
              </div>
            </router-link>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <app-sadko-plus class-name="screen2"></app-sadko-plus>
    <app-sadko-reviews></app-sadko-reviews>
    <app-sadko-contacts></app-sadko-contacts>

    <app-button-go-back :goto="goto"></app-button-go-back>

  </div>
</template>

<script>
export default {
  data () {
    return {
      goto: { path: '/sadko' },
      rooms: this.$store.state.malinaRooms
    }
  }
}
</script>

<style scoped>
#home {
  position: relative;
  top: -150px;
}

.rooms a,
.rooms a:active,
.rooms a:hover,
.rooms a:visited {
  color: black;
  text-decoration: none;
}

.rooms-img {
  height: 80vh;
}

.rooms h1 {
  margin-bottom: 50px;
}

.rooms-block {
  margin: 15px;
  text-align: center;
  border: 1px solid #c3c3c3;
  border-radius: 5px;
}

.rooms-block:hover {
  background-color: #f5f5f5;
  opacity: 0.8;
}

.rooms-h1 {
  font-size: 21px;
  font-weight: 900;
  margin-top: 15px;
}

.rooms-description {
  margin-top: 10px;
  margin-bottom: 10px;
}

.rooms-price {
  font-size: 21px;
  font-weight: 900;
  color: green;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {
  .rooms h1 {
    margin-bottom: 30px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/sadko/Rooms.vue